module.exports = __webpack_public_path__ + "static/media/cq_ultimo_mese_option b.f62c398a.svg";